import React from "react";

import {DataLoadingStatus} from "shared/types/common";
import {SelectOptionsPanel} from "shared/components/inputFields";
import {logTypes} from "../types";
import {useLogs} from "../hooks/useLogs";

const LogsViewPage = () => {
    const {
        lines, setLines,
        includeOld, setIncludeOld,
        selectedLogTypeIdx, setSelectedLogTypeIdx,
        dataLoadingStatus, setDataLoadingStatus,
        logs
    } = useLogs();

    return (
        <div className="logs-page">
            <div style={{display: "flex", flexDirection: "row"}}>
                <div style={{flex: 10}}><SelectOptionsPanel options={logTypes} selectedIdx={selectedLogTypeIdx} setSelectedIdx={setSelectedLogTypeIdx}/></div>
                <div style={{flex: 1, display: "flex", marginTop: 15, paddingRight: 15, justifyContent: "center", alignItems: "center"}}>
                    <div>
                        <input type="number" style={{marginRight: 15}} value={lines} onChange={(e) => {const inputValue = e.target.value; if (/^\d*$/.test(inputValue) && (inputValue === '' || (parseInt(inputValue) >= 1 && parseInt(inputValue) <= 10000))) { setLines(parseInt(inputValue));}}}/>
                        <label style={{marginRight: 15}}>
                            <input type="checkbox" checked={includeOld} onChange={(event) => setIncludeOld(event.target.checked)}/>
                            Include Older
                        </label>
                    </div>
                    <button className="button green-button" onClick={() => setDataLoadingStatus(DataLoadingStatus.NotLoaded)}>Refresh</button>
                </div>
            </div>

            {dataLoadingStatus === DataLoadingStatus.Loading? <p className="info-text">Retrieving logs...</p> : <></>}
            {dataLoadingStatus === DataLoadingStatus.Loaded && logs && logs.log.length === 0? <p className="info-text">No logs of such level found :(</p> : <></>}
            {dataLoadingStatus === DataLoadingStatus.Error? <p className="error-text">Network error occured! Please, reload the page and try again...</p> : <></>}

            {dataLoadingStatus === DataLoadingStatus.Loaded && logs && logs.log.length > 0?
                <div className="scrollable logs-container">
                    {logs.log.map(log => log.includes('[202')? <p className="log"><span className="log-time">{log.split(']')[0]+'] '}</span> {log.split(']').slice(1).join(']')}</p> : <p className="log">{log}</p>)}
                </div>
            : <div style={{flex: 1}}></div>}
        </div>
    );
};

export default LogsViewPage;